<template>
  <Dialog
    :visible="visible"
    :position="position"
    :closeable="closeable"
    :close-on-click-mask="closeOnClickMask"
    @update:visible="handleVisibleUpdate"
  >
    <div class="popup">
      <header v-if="hasHeader" class="popup__header">
        <slot name="title">
          <h3 class="popup__title">{{ title }}</h3>
        </slot>
        <slot name="tips">
          <span v-if="tips" class="popup__tips">{{ tips }}</span>
        </slot>
      </header>
      <div class="popup__body">
        <slot></slot>
      </div>
    </div>
  </Dialog>
</template>

<script>
import Dialog from '@/components/Dialog/Index.vue'

export default {
  name: 'Popup',
  components: {
    Dialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    tips: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'bottom'
    },
    closeable: {
      type: Boolean,
      default: false
    },
    closeOnClickMask: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasHeader() {
      return Boolean(this.title || this.tips || this.$slots.title || this.$slots.tips)
    }
  },
  methods: {
    handleVisibleUpdate(val) {
      this.$emit('update:visible', val)
      if (!val) {
        this.$emit('on-hide')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../stylesheets/base/fn.less';

.popup {
  padding: 40/@w2 40/@w2 16/@w2;
  box-sizing: border-box;

  &__header {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    margin-bottom: 8/@w2;
  }

  &__title {
    font-size: 30/@w2;
    line-height: 42/@w2;
    color: #000;
    font-weight: 600;
    margin: 0;
  }

  &__tips {
    font-size: 22/@w2;
    line-height: 32/@w2;
    color: #999;
    margin-left: 12/@w2;
  }

  &__body {
    margin-top: 16/@w2;
  }
}
</style>
